import React, { useEffect } from "react";
import { DialogContainer } from "./DialogContainer";

export const DialogContext = React.createContext(undefined);
// @ts-ignore
export const useDialog = (): [Function, Function] => React.useContext(DialogContext);

export default function DialogProvider({ children }: { children: any }) {
  const [dialogs, setDialogs] = React.useState<any[]>([]);
  const createDialog = (option: any, disableBackdropClick = false) => {
    const dialog = { ...option, open: true, disableBackdropClick: disableBackdropClick };
    setDialogs((dialogs) => [...dialogs, dialog]);
  };

  const closeDialog = (dialog: any) => {
    setDialogs((dialogs) => {
      const latestDialog = dialogs.pop();
      if (!latestDialog) return dialogs;
      if (latestDialog.onClose) latestDialog.onClose();
      return [...dialogs];
    });
  };

  useEffect(() => {
    window.addEventListener("popstate", (e) => {
      // Nope, go back to your page
      // this.props.history.go(1);
      setDialogs([]);
    });
  }, []);

  const contextValue = React.useRef([createDialog, closeDialog]);

  return (
    // @ts-ignore
    <DialogContext.Provider value={contextValue.current}>
      {children}
      {dialogs.map((dialog, i) => {
        return <DialogContainer key={i} {...dialog} onClose={closeDialog} />;
      })}
    </DialogContext.Provider>
  );
}
